<template>
  <section>
    <qx-search-box
      class="searchBox"
      :searchBoxData="searchBoxData"
      @sub="sub"
      title="筛选"
      permpisionsQuery=""
    >
      <el-alert
        show-icon
        :closable="false"
        title="温馨提示：若需要扣减司机的工资的项目，请在金额前输入“-”号(负号)。"
        type="warning"
      />
      <div slot="hasOrder" slot-scope="prop">
        <el-checkbox label="有" name="type" v-model="prop.form.hasOrder" />
      </div>
      <div slot="isRealSalaryFee" slot-scope="prop">
        <el-checkbox label="有" name="type" v-model="prop.form.isRealSalaryFee" />
      </div>
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>

<script>
import TableBox from './tableBox';
import {
  getEnumList,
} from 'api';
import {
  getQueryMonth,
} from '@qx/utils/index';
import {driverSalaryListName} from 'api/getPay';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        checkStsOptions: [], // 工资状态
        form: [
          { // 业务年月
            label: '业务年月',
            value: 'settleMonth',
            type: 'date',
            default: getQueryMonth(),
            placeholder: '请选择业务年月',
            attr: {
              type: 'month',
            },
          },
          { // 司机姓名
            label: '司机姓名',
            value: 'carDriverName',
            type: 'input',
            placeholder: '请输入司机姓名',
          },
          { // 司机手机
            label: '司机手机',
            value: 'carDriverPhone',
            type: 'input',
            placeholder: '请输入司机手机',
          },
          { // 结算时间
            label: '结算时间',
            value: 'Time',
            type: 'date',
            placeholder: '请选择结算时间',
            attr: {
              type: 'daterange',
            },
          },
          { // 工资状态
            label: '工资状态',
            value: 'checkSts',
            type: 'select',
            default: '-1',
            placeholder: '请选择工资状态',
          },
          { // 工资申诉
            label: '工资申诉',
            value: 'salaryComplainSts',
            type: 'select',
            default: '-1',
            placeholder: '请选择工资申诉',
            options: [
              {
                label: '全部',
                value: '-1',
              },
              {
                label: '有申诉',
                value: '1',
              },
              {
                label: '无申诉',
                value: '2',
              },
            ],
          },
          { // 有无订单
            label: '有无订单',
            value: 'hasOrder',
            default: true,
            slot: true,
          },
          { // 是否有实发费
            label: '是否有实发费',
            value: 'isRealSalaryFee',
            default: true,
            slot: true,
          },
        ],
      },
    };
  },
  methods: {

    /**
     * @param {object} searchBoxData 搜索栏数据
     * @returns {void}
     * @description 搜索栏触发搜索事件，将数据传递给表格box进行保存并刷新数据
     */
    sub (searchBoxData) {
      // 处理时间
      if (searchBoxData.Time && searchBoxData.Time.length > 0) {
        searchBoxData.startTime = this.formatDate(searchBoxData.Time[0]);
        searchBoxData.endTime = this.formatDate(searchBoxData.Time[1]);
        delete searchBoxData.Time;
      }
      if (searchBoxData.settleMonth && searchBoxData.settleMonth.indexOf('T') !== -1) {
        let date = new Date(searchBoxData.settleMonth);
        let nowMonth = date.getMonth();
        let year = date.getFullYear();
        if (Number(nowMonth) >= 0) {
          nowMonth = nowMonth + 1;
        }
        if (Number(nowMonth) >= 1 && Number(nowMonth) <= 9) {
          nowMonth = '0' + nowMonth;
        }
        searchBoxData.settleMonth = year + '-' + nowMonth;
      }
      this.settleMonthChange(searchBoxData);
      const params = {
        driverSts: -1,
        complainSts: -1,
        subComplainSts: -1,
        salaryComplainSts: -1,
        salaryPattern: -1,
        carUserType: 3,
        ...searchBoxData,
      };
      delete params.Time;

      this.$refs.tableBox.saveSearchBoxData(params);
      this.$refs.tableBox.setImportExportParams(params);
    },
    // 业务年月点击
    async settleMonthChange (searchBoxData) {
      const res = await driverSalaryListName({
        settleMonth: searchBoxData.settleMonth,
        channelType: 'WEB',
      });
      if (!res.failed) {
        let data = [];
        res.items.map((item) => {
          item.show = true;
          data.push(item);
        });
        this.$refs.tableBox.tableData.title = data;
      }

      const res1 = await driverSalaryListName({
        settleMonth: searchBoxData.settleMonth,
        channelType: 'WEB-details',
      });

      if (!res1.failed) {
        let downloadParams = { excelKeys: '', excelLables: ''};
        res1.items.map((item) => {
        // 初始化导出订单数据的表头内容
          downloadParams.excelKeys += item.prop + ',';
          downloadParams.excelLables += item.label + ',';
        }
        );
        downloadParams.excelKeys = downloadParams.excelKeys.substring(0, downloadParams.excelKeys.length - 1);
        downloadParams.excelLables = downloadParams.excelLables.substring(0, downloadParams.excelLables.length - 1);
        this.$refs.tableBox.downloadParams = downloadParams;
      }
    },
  },
  async created () {
    const enumsList = await getEnumList({
      codeType: 'SAL_SALARY_STATUS',
    });
    this.searchBoxData.checkStsOptions = [
      {
        label: '全部',
        value: '-1',
      },
      ...enumsList[0],
    ];
  },
};
</script>

<style lang="scss" scoped>
</style>
